import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { enableIndexedDbPersistence, getFirestore } from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC0wz02EN8E6pgUCm9q-R-GhQ-NopuC-ik",
  authDomain: "pzr-lccutracker.firebaseapp.com",
  projectId: "pzr-lccutracker",
  storageBucket: "pzr-lccutracker.appspot.com",
  messagingSenderId: "87969819792",
  appId: "1:87969819792:web:5e2259f34b615887c63c15",
  vapidKey:
    "BAmrHh6_m5znpVo9-XYPgrCpmHEJQJXjBnifzn2hknm-Yvbt_6o7gVMGmzLcRagOQO0IyofmfRAFngZHCcmFzIE",
  databaseURL:
    "https://pzr-lccutracker-default-rtdb.europe-west1.firebasedatabase.app",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const firestoreDB = getFirestore(firebaseApp);
export const firebaseMessaging = getMessaging(firebaseApp);

//Messaging
export const messaging = getMessaging(firebaseApp);

//Real Time Database

export const database = getDatabase(firebaseApp);
